import { isCorporateClient } from '@/composables/useEdverumClient.js';
import { corporateCourseRouteRedirect, isCorporateRemovedCourseRoute } from '@/constants/corporateCourseMenu.js';

/**
 * Corporate course navigation redirects. Only active when EDVERUM_CLIENT=corporate.
 *
 * - Routes merged into the consolidated "Enrollment & Progress" destination
 *   (gradebook + enrollments) redirect to that new page.
 * - Removed administrative routes redirect back to the course dashboard.
 *
 * @type {import('vue-router').NavigationGuardWithThis<undefined>}
 */
export default function CorporateCourseMenuRedirectMiddleware(to, from, next) {
    if (!isCorporateClient()) {
        next();

        return;
    }

    const mergedTarget = corporateCourseRouteRedirect(to.name);
    const isRemoved = isCorporateRemovedCourseRoute(to.name);

    if (!mergedTarget && !isRemoved) {
        next();

        return;
    }

    const courseId = to.params.courseId;

    if (!courseId) {
        next({ name: '403' });

        return;
    }

    next({
        name: mergedTarget ?? 'course-dashboard',
        params: { courseId },
    });
}
